import { Box, Button, Typography } from '@mui/material';
import { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { darkTheme, lightTheme } from "../../layouts/theme/index";
import createCache from "@emotion/cache";
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import Switch from "@mui/material/Switch";
import SingInForum from "../SingInForum/SingInForum"
import {
  getAuthUserinfoApi, requestoauthApi
} from "../../services/authApi";
import { customToastify, checkErrorMessage, checkResponseData } from "../../components/pages/utils/utilsFunctions"


const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});




const ForumLogin = () => {
  const [lighteMode, setLightMode] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [userInfo, setUserInfo] = useState({});


  const handleShowLoginForm = (value, dontGetInfo) => {
    setShowLoginForm(value)
    if (!dontGetInfo) getUserInfo()
  }



  function CheckInitialMode() {
    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode) {
        setLightMode(themeMode);
      } else {
        console.log("Theme Mode is Dark");
      }
    } catch {
      console.log("Problem in theme Mode");
    }
  }



  const getUserInfo = async () => {
    try {
      let response = await getAuthUserinfoApi()
      const resData = checkResponseData(response);
      if (resData["success"]) {
        handleShowLoginForm(true, true)
        setUserInfo(resData["data"]["data"][0])
        // window.location.replace("https://forum.umlang.com")
      } else {
        handleShowLoginForm(false, true)
        customToastify("info", resData["message"], 3000, "top-center");
        localStorage.removeItem("token")
      }
    } catch (error) {
      // console.log("1111")
      // handleResult("ErrorLoadData")
      // console.log("error")
    }
  }


  const CheckUserSignIn = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        await getUserInfo()
      } else {
        handleShowLoginForm(false, true)
      }
    } catch (error) {
      localStorage.removeItem("token")
      // handleResult("registerPage")
    }

  }

  useEffect(() => {
    CheckInitialMode();
    CheckUserSignIn();
  }, []);

  return (
    <CacheProvider value={cacheRTL}>
      <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
        <HelmetProvider>
          <Helmet>
            <title>UMLANG  - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
          </Helmet>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              minHeight: '100vh',
              backgroundColor: lighteMode ? "#42a5f5" : "#3F4652",
            }}
          >
            {showLoginForm ? <Typography sx={{ textAlign: "center" }}>
              {userInfo["email"] ? <>
                <Typography sx={{ mt: 4 }}>
                  شما قبلا ایمیل خود را ثبت کرده اید و قابل ویرایش نمی باشد
                </Typography>
                <Typography sx={{ mt: 4 }}>
                  ضمنا برای اصلاح دیگر مشخصات خود ابتدا به <a href='https://umlang.com' >صفحه اصلی</a>  سایت بروید و بر روی منوی سمت راست سایت کلیک و گزینه پروفایل را انتخاب کنید
                </Typography>
                <Typography >
                  در صورت پیغام خطای ثبت جیمیل یکبار خارج شده و دوباره لاگین کنید
                </Typography>
                <br />
                <a href='https://forum.umlang.com' >رفتن به انجمن</a>
              </> : <>

                <Typography sx={{ mt: 4 }}>
                  برای ثبت ایمیل و اصلاح دیگر مشخصات خود ابتدا به <a href='https://umlang.com' >صفحه اصلی</a>  سایت بروید و بر روی منوی سمت راست سایت کلیک کنید
                </Typography>
                <img src="/img/pic/setgmeil1.png" />
                <Typography>
                  سپس گزینه پروفایل را انتخاب کرده و بر روی ورود با ایمیل کلیک کنید و ادامه مراحل را انجام دهید
                </Typography>
                <img src="/img/pic/setgmeil2.png" style={{ width: "100%" }} />
                <br />

                <a href='https://forum.umlang.com' >رفتن به انجمن</a>
              </>}
            </Typography> :
              <SingInForum handleShowLoginForm={handleShowLoginForm} />
            }
          </Box>
        </HelmetProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default ForumLogin;
